import React from 'react';
// @ts-ignore
import styles from './InsuranceReportsListSubItem.module.scss';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	title: string;
	value: string | number;
}

const InsuranceReportsListSubItem: React.FC<Props> = ({ title, value }) => {
	return (
		<div className={styles.wrapper}>
			<Text tx={title} firstUpper className={styles.title} colon />
			<div className={styles.text}>{value}</div>
		</div>
	);
};

export default InsuranceReportsListSubItem;
